export class AmenitiesFiltersModal {
    private amenities: Array<Amenity>;

    constructor(filtersModal: Element, propertyType: string[]) {
        this.amenities = Array
            .from(filtersModal.querySelectorAll('[name="amenities"]') as NodeListOf<HTMLInputElement>)
            .map(amenity => new Amenity(amenity));

        this.manageVisibilityBasedOn(propertyType)
    }

    public manageVisibilityBasedOn(propertyType: string[]) {
        this.amenities.forEach(amenity => amenity.manageVisibilityBasedOn(propertyType))
    }
}

class Amenity {
    private readonly _HIDE_FOR_ATTRIBUTE = "data-hide-for";
    private readonly _SHOW_FOR_ATTRIBUTE = "data-show-for";

    private element: HTMLInputElement;

    private readonly hideFor: string[] = [];
    private readonly showFor: string[] = [];

    constructor(element: HTMLInputElement) {
        this.element = element;
        this.hideFor = this.getAttribute(this._HIDE_FOR_ATTRIBUTE);
        this.showFor = this.getAttribute(this._SHOW_FOR_ATTRIBUTE);
    }

    private getAttribute(attributeName: string) {
        return (this.element.getAttribute(attributeName)?.split(",") || []).map((v: string) => v.toLowerCase())
    }

    public manageVisibilityBasedOn(propertyType: string[]) {
        this.element.disabled = this.shouldHide(propertyType)
    }

    private shouldHide(propertyType: string[]): boolean {
        return this.isMarkedToHide(propertyType) || !this.isMarkedToShow(propertyType)
    }

    private isMarkedToShow(propertyType: string[]) {
        return this.showFor.length == 0 || this.matches(propertyType, this.showFor)
    }

    public isMarkedToHide(propertyType: string[]) {
        return this.hideFor.length >= 1 &&
            (propertyType.length == 0 || this.matches(propertyType, this.hideFor))
    }

    private matches(propertyType: string[], collection: string[] = []) {
        return propertyType
            .map((value: string) => value.toLowerCase().replace("gt-", ""))
            .some((value: string) => collection.includes(value));
    }
}
